import { useFormikContext } from 'formik';
import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { fileListKey } from 'gcs-common/helper/mediaHelper';
import documentImage from 'gcs-common/img/document.svg';
import type { TicketsState } from 'gcs-common/slices/tickets/ticketsSlice';
import { useState } from 'react';
import useTicketAttachmentFileDrop from '../../../../customHooks/useTicketAttachmentFileDrop';
import LocalFilePreview from '../../../LocalFilePreview/LocalFilePreview';
import PopUpModal from '../../../PopUpModal/PopUpModal';
import TicketErrorModal from '../../TicketAttachmentSizeErrorModal/TicketAttachmentSizeErrorModal';
import styles from './styles.module.scss';

const TicketAttachmentUpload = () => {
  const { values } = useFormikContext<TicketsState['drafts'][string]>();
  const [showAttachmentErrorModal, setShowAttachmentErrorModal] = useState(false);

  const onFileSizeError = () => {
    setShowAttachmentErrorModal(true);
  };

  const { getRootProps, getInputProps, removeFile } = useTicketAttachmentFileDrop({
    fieldName: 'attachments',
    onFileSizeError,
  });

  return (
    <div className={styles.imageWrapper}>
      {values.attachments?.map((file, fileIndex) => (
        <div className={styles.previewWrapper} key={fileListKey(file)}>
          <LocalFilePreview file={file} filePlaceHolder={documentImage} />

          <div className={styles.buttonActions}>
            <button onClick={() => removeFile(fileIndex)} type="button">
              <IconComponent Icon={ICON.CLOSE} color={ICON_COLOR.DARKEST_GREY} />
            </button>
          </div>
        </div>
      ))}
      <div {...getRootProps()} className={styles.attachment}>
        <input {...getInputProps()} data-testid="attachments-input" />
        <IconComponent Icon={ICON.PLUS} size={ICON_SIZE.X_LARGE} />
      </div>
      {showAttachmentErrorModal && (
        <PopUpModal
          title="Ticketerstellung  abbrechen"
          onRequestClose={() => setShowAttachmentErrorModal(false)}
          isOpen
        >
          <TicketErrorModal onCancel={() => setShowAttachmentErrorModal(false)} />
        </PopUpModal>
      )}
    </div>
  );
};

export default TicketAttachmentUpload;
